import { useRef, useCallback } from 'react';
const useCreateCallbackForEvent = (callback) => {
    const refCallback = useRef(callback);
    refCallback.current = callback;
    const eventCallback = useCallback((...args) => refCallback.current && refCallback.current(...args), []);
    return eventCallback;
};
export default useCreateCallbackForEvent;
